
// German translations
export const de = {
  // Navigation
  navigation: {
    services: "Leistungen",
    howWeWork: "Wie Wir Arbeiten",
    technologies: "Technologien",
    caseStudies: "Fallstudien",
    contact: "Kontakt",
  },
  // Hero section
  hero: {
    title: "KI-gestützte Lösungen für moderne Unternehmen",
    subtitle: "Wir entwickeln intelligente Anwendungen, die Effizienz, Innovation und Wachstum fördern",
    ctaButton: "Loslegen",
    secondaryButton: "Mehr Erfahren",
  },
  // Services section
  services: {
    title: "Unsere Dienstleistungen",
    subtitle: "Umfassendes Angebot an Dienstleistungen, die Unternehmen helfen, die Kraft von KI und Daten zu nutzen",
    description: "Wir bieten eine umfassende Suite von KI-Lösungen, die auf Ihre Geschäftsanforderungen zugeschnitten sind",
    learnMore: "Mehr erfahren"
  },
  // Industries section
  industries: {
    title: "Branchen, die wir bedienen",
    manufacturing: "Fertigung",
    infrastructure: "Infrastruktur",
    warehouses: "Lagerhallen",
    supplyChain: "Lieferkette",
    categories: {
      industrialMachinery: "Industriemaschinen",
      threeDPrinting: "3D-Druck",
      roboticSolutions: "Robotiklösungen",
      energy: "Energie",
      dataCenters: "Rechenzentren",
      governmentFacilities: "Regierungseinrichtungen",
      distributionCenters: "Vertriebszentren",
      coldStorage: "Kühllager",
      microFulfillment: "Mikro-Fulfillment",
      retail: "Einzelhandel",
      foodAndAgriculture: "Lebensmittel & Landwirtschaft",
      logisticsAndTransportation: "Logistik & Transport",
    },
  },
  // Process section
  process: {
    title: "Unser Prozess",
  },
  // Technologies section
  technologies: {
    title: "Technologien",
  },
  // Tools section
  tools: {
    title: "Werkzeuge, die wir verwenden",
  },
  // Case studies section
  caseStudies: {
    title: "Fallstudien",
    viewAllButton: "Alle Fallstudien anzeigen",
  },
  // Contact section
  contact: {
    title: "Kontaktieren Sie uns",
    name: "Name",
    email: "E-Mail",
    message: "Nachricht",
    submitButton: "Nachricht senden",
  },
  // Footer
  footer: {
    company: "Unternehmen",
    about: "Über Uns",
    careers: "Karriere",
    resources: "Ressourcen",
    legal: "Rechtliches",
    privacyPolicy: "Datenschutzrichtlinie",
    terms: "AGB",
    cookiePolicy: "Cookie-Richtlinie",
    copyright: "© 2025 KLEXU. Alle Rechte vorbehalten.",
  },
};
